export default __webpack_public_path__ + "static/pay-listing-img-17b31ca97140bfb609304e04bf223b43.png";